export default {
  knobX: 100, // center of SVG viewBox
  knobY: 100,  // center of SVG viewBox
  svg: `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="208px" height="208px" viewBox="0 0 208 208" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="dc99b4d9-9db5-0103-63a8-9e7e86131e79">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="8c78c5f1-c67b-f6bf-d85d-f263256bcca9" cx="100" cy="100" r="100"/>
        <filter x="-3.5%" y="-3.0%" width="107.0%" height="107.0%" filterUnits="objectBoundingBox" id="f3420de8-2234-616a-157b-ba295d08fe50">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="1ae7833b-b35b-aeb4-c74d-a3543215e512">
            <stop stop-color="#EEEEEE" offset="0%"/>
            <stop stop-color="#EDEDED" offset="50.0553592%"/>
            <stop stop-color="#D8D8D8" offset="100%"/>
        </linearGradient>
        <circle id="32a8cad6-2acd-8cc5-54db-d674f2fe10fc" cx="84" cy="84" r="84"/>
        <filter x="-5.1%" y="-5.1%" width="110.1%" height="110.1%" filterUnits="objectBoundingBox" id="4454cb12-350c-d7db-a0af-7d00bca36d2f">
            <feMorphology radius="2.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        
        <filter x="-14.6%" y="-20.7%" width="129.3%" height="141.4%" filterUnits="objectBoundingBox" id="ffa1ba48-8f7b-a60b-b5ed-847509d1cd9c">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.960784314   0 0 0 0 0.650980392   0 0 0 0 0.137254902  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="4" transform="translate(4.000000, 3.000000)">
            <g id="container4">
                <g id="outerouter4">
                    <use fill="black" fill-opacity="1" filter="url(#f3420de8-2234-616a-157b-ba295d08fe50)" xlink:href="#8c78c5f1-c67b-f6bf-d85d-f263256bcca9"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#dc99b4d9-9db5-0103-63a8-9e7e86131e79)" fill-rule="evenodd" xlink:href="#8c78c5f1-c67b-f6bf-d85d-f263256bcca9"/>
                </g>
                <g id="knob" transform="translate(16.000000, 16.000000)">
                    <g id="outercenter4">
                        <use fill="black" fill-opacity="1" filter="url(#4454cb12-350c-d7db-a0af-7d00bca36d2f)" xlink:href="#32a8cad6-2acd-8cc5-54db-d674f2fe10fc"/>
                        <use stroke="#454545" stroke-width="5" fill="url(#1ae7833b-b35b-aeb4-c74d-a3543215e512)" fill-rule="evenodd" xlink:href="#32a8cad6-2acd-8cc5-54db-d674f2fe10fc"/>
                    </g>
                    <circle id="innercenter4" stroke="#454545" fill="#3D3D3D" cx="84" cy="84" r="40"/>
                    <path d="M84.5,1 L101,62.0983622 C95.7956227,63.6405904 90.2956227,64.402938 84.5,64.385405 C78.7043773,64.3678721 73.2043773,63.6055245 68,62.0983622 L84.5,1 Z" id="marker4" fill="#3D3D3D" transform="translate(84.500000, 32.692850) scale(1, -1) translate(-84.500000, -32.692850) "/>
                </g>
                <g id="labelcontainer4" transform="translate(78.000000, 86.000000)" fill="#F5A623" fill-opacity="1">
                    <g id="labeltext4">
                        <text id="c93c01bf-8a04-d8f0-7dbb-213cad479fa3" font-family="Helvetica" font-size="24" font-weight="normal" fill="#F5A623" class="text-7" filter="url(#ffa1ba48-8f7b-a60b-b5ed-847509d1cd9c)">
            <tspan x="0.728515625" y="23">100</tspan>
        </text>
                        <text id="248c0941-8c8d-bd41-82f2-08ec891cd8bf" font-family="Helvetica" font-size="24" font-weight="normal" fill="#F5A623" class="text-7">
            <tspan x="0.728515625" y="23">100</tspan>
        </text>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`,
  updateAttributes: [
    {
      element: "#labelcontainer4 text tspan",
      content: (props, value) => {
        return value.toFixed(0);
      },
      attrs: [
        {
          name: "text-anchor",
          value: (props, value) => {
            return "middle";
          }
        },
        {
            name: "x",
            value: (props, value) => {
              return "23";
            }
          }
      ]
    }
  ]
};